<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-2">{{ $t('view')}} {{$tc('checklist', 1)}}</div>
      <div>
        <router-link
          class="btn-blue"
          :to="{ name: 'Edit Checklist',params:{checklist_id: checklist_id}}"
        >{{ $t('edit') }}</router-link>
        <router-link class="btn-blue" :to="{name:'List Checklists'}">{{ $tc('checklist', 2)}}</router-link>
      </div>
    </div>
    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('checklist') }} {{ $t('name') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{checklist_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('categoryname') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{category_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('cinemaname') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{cinema_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $tc('status', 1) }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{checklist_is_active}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('checklist') }} {{ $t('items') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span
              v-for="(item, itemIndex) in checkListItems"
              :key="itemIndex"
              class="mr-3"
            >{{item.item}}</span>
          </div>
        </div>
      </div>
      <!-- v-if="GetRoleId && GetRoleId === 1" -->
      <div v-if="GetRoleId && GetRoleId === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('createdby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ created_by }}</span>
          </div>
        </div>
      </div>
      <div v-if="GetRoleId && GetRoleId === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('createdat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ created_at | dateparse }}</span>
          </div>
        </div>
      </div>
      <div v-if="GetRoleId && GetRoleId === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('modifiedby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ updated_by }}</span>
          </div>
        </div>
      </div>
      <div v-if="GetRoleId && GetRoleId === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('modifiedat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ updated_at | dateparse }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChecklistService from "@/services/ChecklistService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      checklist_name: "",
      category_name: "",
      cinema_name: "",
      checklist_is_active: null,
      checkListItems: [],
      created_by: null,
      created_at: null,
      updated_by: null,
      updated_at: null,
      checklist_id: null
    };
  },
  mounted() {
    this.getChecklistData();
  },
  methods: {
    getChecklistData() {
      const { checklist_id } = this.$route.params;
      this.checklist_id = checklist_id;
      ChecklistService.GetChecklistData({ checklist_id: checklist_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.checklist_name = data.Records[0].checklist_name;
              this.cinema_name = data.Records[0].cine_name;

              this.category_name = data.Records[0].cc_name;

              this.checklist_is_active = data.Records[0].checklist_is_active = "Y"
                ? "Active"
                : "Inactive";

              this.created_at = data.Records[0]["created_at"];
              this.updated_at = data.Records[0]["updated_at"];

              this.getViewUsersDetails(
                data.Records[0]["created_by"],
                "created_by"
              );
              this.getViewUsersDetails(
                data.Records[0]["updated_by"],
                "updated_by"
              );

              data.Records.map(x => {
                this.checkListItems.push({
                  item: x.checklist_item,
                  item_id: x.checklist_item_id
                });
              });
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getViewUsersDetails(user_id, key) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key] = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch(error => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ChecklistComponents/viewChecklist.vue